// dependecies import ==>
import React, { createRef, useEffect, useState } from "react";
import swal from "sweetalert";
// project file import ==>
import "./viewDocuments.scss";
import DisplayUploadedFiles from "../common/DisplayUploadedFiles";
import Loader from "../UI Component/Loader/Loader";
import ShareManualRxModal from "../ManualRX/ShareManualRxMoadal";
import AbhaHealthRecord from "./AbhaHealthRecord";
// constant import ==>
import { getSignedUrl } from "../../Util/API Calls/SignedAPIUrl";
import {
  GET_PATIENT_DOCTOR_DOCUMENTS,
  GET_Rx_ERx_PRESCRIPTION,
  SHARE_MANUAL_PRESCRIPTION,
  SHARE_PRESCRIPTION,
  UPLOAD_DOCUMENT,
} from "./ViewDocumentsApiHandler/apiConstants";
import { APPLICABLE_ROLE } from "../DashboardAppointmentsView/Constant";
import { CONSULTATION_TYPE } from "../common/DashboardAccounts/constant";
import { APPROVE_AND_SHARE_ERX } from "../PrescriptionTabComponent/PrescriptionTabAPIHandler/APIconstants";
import { REPORT_OPTIONS } from "./constant";
import {
  getSharedPrescriptionResponse,
  approveAndShareRxData,
} from "../PrescriptionTabComponent/PrescriptionTabAPIHandler";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import DragAndDrop from "../ERXViewContainer/common/DragAndDrop";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";

const ViewDocuments = (props) => {
  const {
    documentShow,
    appointmentData,
    prescriptionState,
    showAbhaHealthRecord,
    children,
    handleViewDocument,
    appointmentDetails,
  } = props;

  let user_type = localStorage.getItem("user_type");
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  let fileRef = createRef();

  const [activeTab, setActiveTab] = useState(1);
  const [patientDocs, setPatientDocs] = useState([]);
  const [doctorDocs, setDoctorDocs] = useState([]);
  const [rxErxDocs, setRxErxDocs] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showRxModal, setShowRxModal] = useState(false);

  const acceptedFileType = { allow: "image/*,.doc, .docx,.pdf,.txt,.xls,.csv" };

  // Lifecycle Methods ===>

  useEffect(() => {
    setLoader(true);
    getPatientDoctorDocuments();
    getPrescriptions();
  }, []);

  // <===

  // Actions ===>

  const handleActiveTab = (val) => {
    setActiveTab(val);
  };

  const hanldeChooseFile = () => {
    fileRef.click();
  };

  const handleOnDrag = (e) => {
    e.preventDefault();
    let files = e.dataTransfer.files;
    calcTotalFileSize(files, e);
  };

  const calcTotalFileSize = (files, e) => {
    let totalSize = 0;
    Object.keys(files).forEach((f) => {
      let fileSize = files[f].size / 1024 / 1024; //File Size in mb
      totalSize += fileSize;
    });
    uploadedFile.forEach((file) => {
      let fileSize = file.size / 1024 / 1024; //File Size in mb
      totalSize += fileSize;
    });

    if (totalSize.toFixed(2) > 20) {
      swal({
        title: "File Size Exceeds Limit!",
        text: `Total File Size cannot be greater than 20 MB`,
        icon: "error",
      });
    } else {
      handleFiles(files, e);
    }
  };

  const handleFileChange = (e) => {
    let files = e.target.files;
    calcTotalFileSize(files, e);
  };

  const handleFiles = (files, e) => {
    let list = uploadedFile;
    for (const file of files) {
      let lastInd = file.name.lastIndexOf(".");
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const isAllowedFileType = /\.(jpg|jpeg|png|bmp|svg|gif|pdf)$/i.test(
          file.name
        );

        const fileObject = {
          name: file.name,
          size: (file.size / 1024 / 1024).toFixed(2),
          type: file.name.substring(lastInd + 1),
          fileName: file.name.substring(0, lastInd),
          fileType: file.type,
          lastModified: file.lastModified,
          lastModifiedDate: file.lastModifiedDate,
          fileDate: file,
          dropdownOptions: REPORT_OPTIONS.map((option) => ({
            ...option,
            selected: isAllowedFileType
              ? appointmentDetails?.account_type == 1
                ? option.label === "Diagnostic Report"
                : option.label === "OP Consultation"
              : option.label === "Other",
            disabled: isAllowedFileType ? false : option.label !== "Other",
          })),
          documentType: isAllowedFileType
            ? appointmentDetails?.account_type == 1
              ? 1
              : 5
            : 9,
          label: isAllowedFileType
            ? appointmentDetails?.account_type == 1
              ? "Diagnostic Report"
              : "OP Consultation"
            : "Other",
          selected: true,
        };

        let filePath = fileObject.name;
        let allowedExtensions =
          /(\.jpg|\.jpeg|\.png|\.bmp|\.svg|\.doc|\.docx|\.pdf|\.txt|\.gif|\.xls|\.csv)$/i;
        if (!allowedExtensions.exec(filePath)) {
          alert(
            "The allowed extension is .jpeg/.jpg/.png/.gif/.svg/.bmp/.pdf/.doc/.xls/.csv/.docx only."
          );
        } else {
          list.push(fileObject);
          setUploadedFile([...list]);
        }
      };
    }

    e.target.value = null;
  };

  const removeUploadedDocument = (ind) => {
    uploadedFile.splice(ind, 1);
    setUploadedFile([...uploadedFile]);
  };

  const handlePurposeChange = (index, selectedValue) => {
    const updatedFileList = uploadedFile.map((file, i) => {
      if (i === index) {
        const updatedDropdownOptions = file.dropdownOptions.map((option) => ({
          ...option,
          selected: option.label === selectedValue.label,
        }));
        return {
          ...file,
          documentType: selectedValue.value,
          label: selectedValue.label,
          selected: true,
          dropdownOptions: updatedDropdownOptions,
        };
      }
      return file;
    });
    setUploadedFile(updatedFileList);
  };

  // <===

  // Api Calls ===>

  const getPatientDoctorDocuments = () => {
    let reqPayload = { appointment_id: appointmentData?.app_id?.id };

    let resData = c2cPostApiHandler(GET_PATIENT_DOCTOR_DOCUMENTS, reqPayload);
    resData.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200 && res?.data?.data?.length !== 0) {
          let patntDocs = [],
            docDocs = [];
          res.data.data.forEach((doc, index) => {
            let lastDot = doc.document_title.lastIndexOf(".");
            let fileName =
              doc.document_title.substring(0, lastDot) ||
              "Medical Record" + index;
            let fileType = doc.document_title.substring(lastDot + 1) || "";

            let reportOption = REPORT_OPTIONS.find(
              (option) => option.value === parseInt(doc.category)
            );
            let categoryLabel = reportOption ? reportOption.label : "";

            if (doc.uploaded_by.toLowerCase() === "patient") {
              patntDocs.push({
                ...doc,
                fileName: fileName,
                fileType: fileType,
                category: categoryLabel,
              });
            } else {
              docDocs.push({
                ...doc,
                fileName: fileName,
                fileType: fileType,
                category: categoryLabel,
              });
            }
          });
          setPatientDocs([...patntDocs]);
          setDoctorDocs([...docDocs]);
        } else {
          setPatientDocs([]);
          setDoctorDocs([]);
        }
      } else {
        setPatientDocs([]);
        setDoctorDocs([]);
      }
    });
  };

  const getPrescriptions = () => {
    let reqPayload = {
      appointment_id: appointmentData?.app_id?.id,
    };

    let resData = c2cPostApiHandler(GET_Rx_ERx_PRESCRIPTION, reqPayload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res?.data?.statusCode === 200 && res?.data?.data?.length !== 0) {
          let data = res.data.data;
          let count = 1;
          let rxCount = 1;
          data.forEach((doc) => {
            let lastDot = doc.document_title.lastIndexOf(".");
            let fileType = doc.document_title.substring(lastDot + 1) || ".pdf";

            if (doc.doc_type === "erx") {
              rxErxDocs.push({
                ...doc,
                fileName: "E-Prescription " + (count < 10 ? "0" : "") + count,
                fileType: fileType,
              });
              count += 1;
            } else {
              rxErxDocs.push({
                ...doc,
                fileName:
                  doc.document_title.substring(0, lastDot) ||
                  "Medical Record" + rxCount,
                fileType: fileType,
              });
              rxCount += 1;
            }
          });

          setRxErxDocs([...rxErxDocs]);
        } else {
          setRxErxDocs([]);
        }
      }
    });
  };

  const shareErx = (doc) => {
    // either saved or shared
    if (doc?.status.toLowerCase() === "shared") {
      shareSharedErx(doc);
    } else {
      // saved -> consultation type
      shareSavedErx(doc);
    }
  };

  const shareSavedErx = (doc) => {
    setLoader(true);
    let reqPayload = {
      "authorizer-principal-id": {
        user_id: userId,
        user_type: "1",
      },
      appointment_id: doc?.appointment_id,
      prescription_id: doc?.saved_prescription_id,
    };
    let apiCallForShare = "";
    if (
      doc?.consultation_type === CONSULTATION_TYPE.INSTANT ||
      doc?.consultation_type === CONSULTATION_TYPE.TELE_CONSULT_FOLLOW_UP ||
      doc?.consultation_type === CONSULTATION_TYPE.TELE_CONSULT_REGULAR
    ) {
      apiCallForShare = getSharedPrescriptionResponse(reqPayload);
    } else {
      apiCallForShare = approveAndShareRxData(
        reqPayload,
        APPROVE_AND_SHARE_ERX
      );
    }
    apiCallForShare.then(([res, error]) => {
      if (!error) {
        setShowRxModal(true);
      }
      setLoader(false);
    });
  };

  const shareSharedErx = (doc) => {
    let reqPayload = {
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staffId : userId,
      appointment_id: doc.appointment_id,
      prescription_id: doc.prescription_id,
    };
    setLoader(true);
    let resData = c2cPostApiHandler(SHARE_PRESCRIPTION, reqPayload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res.data.statusCode === 200) {
          setShowRxModal(true);
        }
      }
    });
  };

  const shareManualRx = (doc) => {
    let data = {
      doc_data: doc.document_path,
      file_size: doc.file_size,
      doc_title: doc.document_title,
    };
    let params = {};

    if (appointmentData?.doctor_id || userId) {
      params["doctor_id"] = appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : userId;
    }
    let reqPayload = {
      user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
      user_id: user_type === APPLICABLE_ROLE.STAFF ? staffId : userId,
      ...params,
      appointment_id: doc.appointment_id,
      prescriptions: [data],
      document_id: doc.document_id,
      prescription_status:
        rxErxDocs.length > 0 || prescriptionState.isERxCreated
          ? "edited"
          : "created",
    };
    setLoader(true);
    let resData = c2cPostApiHandler(SHARE_MANUAL_PRESCRIPTION, reqPayload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res.data.statusCode === 200) {
          setShowRxModal(true);
        }
      }
    });
  };

  const handleUploadDocument = async () => {
    setLoader(true);
    let updatedPayload = [];
    for (const file of uploadedFile) {
      let payload = {
        file_size: file.size,
        doc_title: file.name,
        user_type: user_type,
        use_case: "book-appointment-add-details_rev1",
        user_id: user_type === APPLICABLE_ROLE.DOCTOR ? userId : staffId,
        uploader_id:
          user_type === APPLICABLE_ROLE.DOCTOR
            ? 1
            : user_type === APPLICABLE_ROLE.STAFF && 4,
        document_type: file?.documentType,
      };

      let signedUrl = await getSignedUrl(payload, file.fileDate);
      if (signedUrl) {
        updatedPayload.push({
          appointment_id: appointmentData?.app_id?.id,
          document_path: signedUrl.fields["key"],
          document_title: file.name,
          document_size: payload.file_size,
          uploader_source: "web",
          uploader_id: payload.user_id,
          uploader_type: payload.uploader_id,
          document_type: file?.documentType,
        });
      }
    }

    let reqPayload = {
      appointment_id: appointmentData?.app_id?.id,
      notification_sent: true,
      docs: updatedPayload,
    };

    let resData = c2cPostApiHandler(UPLOAD_DOCUMENT, reqPayload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err && res?.data?.statusCode === 200) {
        setUploadedFile([]);
        getPatientDoctorDocuments();
        swal({
          icon: "success",
          title: "Document uploaded successfully!",
          timer: 2000,
        });
      } else {
        swal({
          icon: "error",
          title: "Error uploading a file. Please try again.",
          timer: 2000,
        });
      }
    });
  };

  // <===

  // Display UI ===>

  const displayViewDocumentsTabs = () => {
    return (
      <div className="view-documents-tabs-cont">
        <div
          className={`view-documents-tabs ${
            showAbhaHealthRecord
              ? "view-document-tab-width"
              : "view-document-tab-width-sec"
          } ${activeTab === 1 ? "view-documents-tab-selected" : ""}`}
          onClick={() => handleActiveTab(1)}
        >
          Patient Document{patientDocs.length > 1 ? "s" : ""}
        </div>
        <div
          className={`view-documents-tabs ${
            showAbhaHealthRecord
              ? "view-document-tab-width"
              : "view-document-tab-width-sec"
          } ${activeTab === 2 ? "view-documents-tab-selected" : ""}`}
          onClick={() => handleActiveTab(2)}
        >
          Doctor Document{doctorDocs.length > 1 ? "s" : ""}
        </div>
        <div
          className={`view-documents-tabs ${
            showAbhaHealthRecord
              ? "view-document-tab-width"
              : "view-document-tab-width-sec"
          } ${activeTab === 3 ? "view-documents-tab-selected" : ""}`}
          onClick={() => handleActiveTab(3)}
        >
          {"Past Rx & eRx"}
        </div>
        {showAbhaHealthRecord && (
          <div
            className={`view-documents-tabs ${
              showAbhaHealthRecord
                ? "view-document-tab-width"
                : "view-document-tab-width-sec"
            } ${activeTab === 4 ? "view-documents-tab-selected" : ""}`}
            onClick={() => handleActiveTab(4)}
          >
            {"ABHA Health Record"}
          </div>
        )}
      </div>
    );
  };

  const displayViewDocumentsTabContents = () => {
    return (
      <div className="view-documents-tab-content">
        {activeTab === 1 && <div>{displayPatientDocuments()}</div>}
        {activeTab === 2 && <div>{displayDoctorDocuments()}</div>}
        {activeTab === 3 && <div>{displayErxDocuments()}</div>}
        {activeTab === 4 && (
          <div>
            {<AbhaHealthRecord appointmentDetails={appointmentDetails} />}
          </div>
        )}
      </div>
    );
  };

  const displayPatientDocuments = () => {
    return (
      <>
        {patientDocs.length !== 0 ? (
          <>
            {patientDocs.map((doc) => (
              <div key={doc.document_id} className="view-uploaded-docs">
                <DisplayUploadedFiles
                  data={doc}
                  fileName={doc.fileName}
                  fileType={doc.fileType}
                  downloadUrl={doc.presigned_url}
                  fileDateTime={doc.created_at}
                  viewDocument={() =>
                    handleViewDocument(
                      doc.presigned_url_view,
                      doc.fileName,
                      doc.fileType
                    )
                  }
                />
              </div>
            ))}
          </>
        ) : (
          displayNoDocumentFound()
        )}
      </>
    );
  };

  const displayNoDocumentFound = () => {
    return (
      <div className="no-document-found">{!loader && "No Document Found"}</div>
    );
  };

  const displayDoctorDocuments = () => {
    return (
      <>
        {doctorUploadDocuments()}
        <div className="doctor-documents-header" style={{ marginTop: "25px" }}>
          View Document{doctorDocs.length > 1 ? "s" : ""}
        </div>
        {doctorDocs.length !== 0 ? (
          <>
            {doctorDocs.map((doc) => (
              <div key={doc.document_id} className="view-uploaded-docs">
                <DisplayUploadedFiles
                  data={doc}
                  fileName={doc.fileName}
                  fileType={doc.fileType}
                  downloadUrl={doc.presigned_url}
                  uploadedBy={doc.uploader_name}
                  fileDateTime={doc.created_at}
                  viewDocument={() =>
                    handleViewDocument(
                      doc.presigned_url_view,
                      doc.fileName,
                      doc.fileType
                    )
                  }
                />
              </div>
            ))}
          </>
        ) : (
          displayNoDocumentFound()
        )}
      </>
    );
  };

  const doctorUploadDocuments = () => {
    return (
      <div className="doctor-upload-documents-ui">
        <div
          className="doctor-documents-header"
          style={{ marginBottom: "15px" }}
        >
          Upload Documents
          <div className="doctor-upload-documents-file-size">
            MAX FILE SIZE 20 MB
          </div>
        </div>
        <DragAndDrop
          fileList={uploadedFile}
          handleDeleteFile={removeUploadedDocument}
          handleOnDrag={handleOnDrag}
          handleOpenFile={hanldeChooseFile}
          handleUpload={handleUploadDocument}
          showDropDown={true}
          handleDropDownChange={handlePurposeChange}
        />
        <input
          type="file"
          ref={(ref) => (fileRef = ref)}
          style={{ display: "none" }}
          onChange={handleFileChange}
          multiple={true}
          accept={acceptedFileType.allow}
        />
      </div>
    );
  };

  const displayErxDocuments = () => {
    return (
      <>
        {rxErxDocs.length !== 0 ? (
          <>
            {rxErxDocs.map((doc) => (
              <div key={doc.document_id} className="view-uploaded-docs">
                <DisplayUploadedFiles
                  data={doc}
                  fileName={doc.fileName}
                  fileType={doc.fileType}
                  downloadUrl={doc.presigned_url}
                  uploadedBy={doc.doc_type === "rx" && doc.uploader_name}
                  fileDateTime={doc.created_at.split("+")[0]}
                  viewDocument={() =>
                    handleViewDocument(
                      doc.presigned_url_view,
                      doc.fileName,
                      doc.fileType,
                      true
                    )
                  }
                  shareRxErx={doc.doc_type === "erx" ? shareErx : shareManualRx}
                />
              </div>
            ))}
          </>
        ) : (
          displayNoDocumentFound()
        )}
      </>
    );
  };

  // <===

  return (
    <div className="view-documents-cont">
      {loader && <Loader />}
      {documentShow ? (
        children
      ) : (
        <>
          {displayViewDocumentsTabs()}
          {displayViewDocumentsTabContents()}
        </>
      )}
      <ShareManualRxModal
        show={showRxModal}
        handleClose={() => {
          setShowRxModal(false);
        }}
      />
    </div>
  );
};

export default ViewDocuments;
